import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BeneficiarySearchParameterDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/beneficiary-search-parameter-dto";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { UserService } from "src/app/ui/services/user.service";
import { BeneficiaryDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/beneficiary-dto";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { ExportBeneficiariesService } from "src/app/ui/services/pbm/export-beneficiaries.service";
import { Toast } from "../../../toast/toast";
import { FilterBeneficiarySearchParameterByExportDTO } from "src/app/ui/models/domains/pbm/Beneficiary/interfaces/IFilterBeneficiarySearchParameterByExport";
import { ExportService } from "src/app/ui/services/export.service";
import { DatePipe } from "@angular/common";
import { merge } from "rxjs";
import { startWith, catchError, switchMap } from "rxjs/operators";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { Gender } from "src/app/ui/models/domains/pbm/Beneficiary/person";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { Router } from "@angular/router";
import { MaritalLabel } from "src/app/ui/models/domains/pbm/Beneficiary/marital-status-type";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "export-beneficiaries",
  templateUrl: "./export-beneficiaries.component.html",
  styleUrls: ["./export-beneficiaries.component.scss"],
})
export class ExportBeneficiariesComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("dialogTemplate") dialogTemplate: TemplateRef<any>;
  public dialogRef: MatDialogRef<any, any>;

  private userProfile = this.userService.getUserProfile();

  public displayedColumns: Array<string> = ["check", "name", "dataCadastro", "dependent", "active", "totalSelected"];

  public dateMask = MaskInput.getDateMask();

  public totalPerPagesOptions: number[] = [10, 25, 50, 100];

  public count: number = 0;
  private company: Company;
  hasChanges: boolean = false;

  constructor(
    private featureViewService: FeatureViewService,
    private exportService: ExportBeneficiariesService,
    private companyService: CompanyService,
    private userService: UserService,
    private dialog: MatDialog,
    private toast: Toast,
    private exportInternalService: ExportService,
    private datePipe: DatePipe,
    private router: Router,
  ) {}

  async ngAfterViewInit() {
    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(async () => {
          if (this.getProcessStatus() === 0) {
            if (this.userProfile.getPreferences().getFilterText().length > 0) {
              await this.searchBenefiaries();
            }
          }
        }),
        catchError(() => {
          return [];
        }),
      )
      .subscribe();
  }

  ngOnInit() {
    if (this.userProfile.getPreferences().getFilterText().length > 0) {
      this.featureViewService.activeFeatureView(FeatureViews.BeneficiaryExportFeatureView, PageViews.BeneficiaryPageView);
      this.userProfile = this.userService.getUserProfile();
      this.findCompany();
      this.getFilters().valueChanges.subscribe((x) => {
        this.hasChanges = true;
      });
    } else {
      this.router.navigate([RoutePath.SearchBeneficiary]);
      this.toast.showWarningToast("É necessário selecionar uma empresa para continuar");
    }
  }

  hasCompany(): boolean {
    return !!this.company;
  }

  getCompany(): Company {
    return this.company;
  }

  async findCompany() {
    try {
      this.company = await this.companyService.findCompanyBy(this.userProfile.getPreferences().getFilterText());
    } catch {
      this.company = null;
      this.toast.showWarningToast("Empresa não encontrada");
    }
  }

  private initialValues(): void {
    this.getSelectedBeneficiries().clear();
    this.exportService.setProcessStatus(0);
  }

  getProcessStatus(): number {
    return this.exportService.getProcessStatus();
  }

  getAllowedBeneficiries() {
    return this.exportService.getBeneficiries();
  }

  getSelectedBeneficiries() {
    return this.exportService.getSelectedBeneficiaries();
  }

  hasSelectedBeneficiries() {
    return this.getSelectedBeneficiries().selected.length > 0;
  }

  getFilters() {
    return this.exportService.getFilters();
  }

  getResultLenght() {
    this.count = this.exportService.getResultLenght();
  }

  public openConfiguracoes() {
    this.dialogRef = this.dialog.open(this.dialogTemplate, {
      width: "500px",
    });
  }

  public onDialogClose() {
    this.dialogRef.close();
  }

  public async searchBenefiaries() {
    this.initialValues();

    if (this.hasChanges) {
      this.paginator.pageIndex = 0;
      this.hasChanges = false;
    }

    let params: BeneficiarySearchParameterDTO = {
      StartIndex: this.paginator.pageIndex + 1,
      TotalPerPages: this.paginator.pageSize,
      FiscalNumber: this.userProfile.getPreferences().getFilterText(),
      Filters: this.filtered(),
    };
    await this.exportService.filterbeneficiries(params).then(() => this.getResultLenght());
  }

  public async filterBenefiaries() {
    this.initialValues();
    this.paginator.pageIndex = 0;

    let params: BeneficiarySearchParameterDTO = {
      StartIndex: 1,
      TotalPerPages: this.paginator.pageSize,
      FiscalNumber: this.userProfile.getPreferences().getFilterText(),
      Filters: this.filtered(),
    };
    await this.exportService.filterbeneficiries(params).then(() => this.getResultLenght());
    this.hasChanges = false;
  }

  public filtered(): FilterBeneficiarySearchParameterByExportDTO {
    let StartDate;
    let EndDate;
    let ExportType;
    let CardState;

    if (this.getFilters().get("startDate").value !== "") {
      var date = this.getFilters().get("startDate").value.split("/");
      StartDate = `${date[2]}-${date[1]}-${date[0]}T` + "00:00:00";
      EndDate = `${date[2]}-${date[1]}-${date[0]}T` + "23:59:59";
    }

    if (this.getFilters().get("endDate").value !== "") {
      var date = this.getFilters().get("endDate").value.split("/");
      EndDate = `${date[2]}-${date[1]}-${date[0]}T` + "23:59:59";
    }

    ExportType = this.getFilters().get("typeExport").value;
    CardState = this.getFilters().get("cardState").value;
    return {
      StartDate: StartDate,
      EndDate: EndDate,
      ExportType: ExportType,
      CardState: CardState,
    };
  }

  public getShowClearButtom(): boolean {
    return this.getFilters().get("startDate").value != "" || this.getFilters().get("endDate").value != "";
  }

  public isAllSelected() {
    this.exportService.isAllSelected();
  }

  public masterToggle() {
    this.exportService.masterToggle();
  }

  public selectBeneficiary(event: any, index: BeneficiaryDTO) {
    this.exportService.selectBeneficiary(event, index);
  }

  public getIsSelected(index: BeneficiaryDTO): number {
    return this.exportService.getIsSelected(index);
  }

  public getSelectedDescription(): string {
    return this.getSelectedBeneficiries().selected.length == 0
      ? "0 selecionada"
      : this.getSelectedBeneficiries().selected.length == 1
      ? "1 selecionada"
      : this.getSelectedBeneficiries().selected.length + " selecionadas";
  }

  public doActionReport() {
    if (this.getProcessStatus() == 2) {
      this.exportService.clearFields();
    } else {
      this.processExport();
    }
  }

  getProcessStyle(): any {
    if (this.getProcessStatus() == 1 || this.getAllowedBeneficiries().data.length == 0) {
      return { opacity: "0.5" }; //estilo botão desabilitado
    }
    return {};
  }

  clearFields() {
    this.exportService.clearFields();
  }

  ngOnDestroy() {
    this.exportService.clearFields();
  }

  async processExport(): Promise<any> {
    this.exportService.setProcessStatus(1);
    const columns: any[] = [
      { value: "CNPJ_EMPRESA", key: "Cnpj" },
      { value: "TIPO", key: "Dependent" },
      { value: "MATRICULA", key: "Registration" },
      { value: "DATA_ADMISSAO", key: "AdmissionDate" },
      { value: "CARGO", key: "JobName" },
      { value: "CPF_TITULAR", key: "SocialNumber" },
      { value: "CPF_DEPENDENTE", key: "SocialNumberDependent" },
      { value: "NOME_COMPLETO", key: "Name" },
      { value: "SEXO", key: "Gender" },
      { value: "ESTADO_CIVIL", key: "MaritalStatus" },
      { value: "DATA_NASCIMENTO", key: "BirthDate" },
      { value: "ENDERECO", key: "Street" },
      { value: "NUMERO", key: "AddressNumber" },
      { value: "COMPLEMENTO", key: "Complement" },
      { value: "BAIRRO", key: "District" },
      { value: "CEP", key: "ZipCode" },
      { value: "CIDADE", key: "City" },
      { value: "ESTADO", key: "Region" },
      { value: "MESMO_ENDERECO_TITULAR", key: "IsNewAddress" },
      { value: "E_MAIL", key: "Email" },
      { value: "VALIDAR_EMAIL_PROXIMO_ACESSO", key: "NeedValidateEmail" },
      { value: "TELEFONE", key: "Telephone" },
      { value: "CELULAR", key: "Mobile" },
      { value: "HABILITAR_DELIVERY", key: "EnableDelivery" },
      { value: "DATA_CADASTRO", key: "ActivationDate" },
      { value: "SITUAÇÃO", key: "Active" },
    ];
    let rows: any[] = [];

    if (this.getSelectedBeneficiries().selected.length > 0) {
      this.getSelectedBeneficiries().selected.forEach((p) => {
        rows.push({
          Cnpj: this.userProfile.getPreferences().getFilterText(),
          Dependent: p.Dependent ? "Dependente" : "Titular",
          Registration: p.Registration,
          AdmissionDate: this.datePipe.transform(p.AdmissionDate, "dd/MM/yyyy"),
          JobName: p.JobName,
          SocialNumber: p.Dependent ? p.SocialNumberTitular : p.SocialNumber,
          SocialNumberDependent: p.Dependent ? p.SocialNumber : "",
          Name: p.Name,
          Gender: new Gender().getOptions()[p.Gender.toString()],
          MaritalStatus: MaritalLabel.get(p.MaritalStatus),
          BirthDate: this.datePipe.transform(p.BirthDate, "dd/MM/yyyy"),
          Street: p.Dependent ? (p.IsNewAddress ? p.Street : "") : p.Street,
          AddressNumber: p.Dependent ? (p.IsNewAddress ? p.AddressNumber : "") : p.AddressNumber,
          Complement: p.Dependent ? (p.IsNewAddress ? p.Complement : "") : p.Complement,
          District: p.Dependent ? (p.IsNewAddress ? p.District : "") : p.District,
          ZipCode: p.Dependent ? (p.IsNewAddress ? p.ZipCode : "") : p.ZipCode,
          City: p.Dependent ? (p.IsNewAddress ? p.City : "") : p.City,
          Region: p.Dependent ? (p.IsNewAddress ? p.Region : "") : p.Region,
          IsNewAddress: p.Dependent ? (p.IsNewAddress ? "Sim" : "Nao") : "",
          Email: p.Email,
          NeedValidateEmail: p.NeedValidateEmail ? "Sim" : "Nao",
          Telephone: p.Telephone,
          Mobile: p.Mobile,
          EnableDelivery: p.EnableDelivery ? "Sim" : "Nao",
          ActivationDate: this.datePipe.transform(p.ActivationDate, "dd/MM/yyyy"),
          Active: p.Active ? "Ativado" : "Desativado",
        });
      });
    } else {
      let params: BeneficiarySearchParameterDTO = {
        StartIndex: 1,
        TotalPerPages: this.count,
        FiscalNumber: this.userProfile.getPreferences().getFilterText(),
        Filters: this.filtered(),
      };
      const response = await this.exportService.searchbeneficiries(params);

      if (response.length > 0) {
        response.forEach((p) => {
          rows.push({
            Cnpj: this.userProfile.getPreferences().getFilterText(),
            Dependent: p.Dependent ? "Dependente" : "Titular",
            Registration: p.Registration,
            AdmissionDate: this.datePipe.transform(p.AdmissionDate, "dd/MM/yyyy"),
            JobName: p.JobName,
            SocialNumber: p.Dependent ? p.SocialNumberTitular : p.SocialNumber,
            SocialNumberDependent: p.Dependent ? p.SocialNumber : "",
            Name: p.Name,
            Gender: new Gender().getOptions()[p.Gender.toString()],
            MaritalStatus: MaritalLabel.get(p.MaritalStatus),
            BirthDate: this.datePipe.transform(p.BirthDate, "dd/MM/yyyy"),
            Street: p.Dependent ? (p.IsNewAddress ? p.Street : "") : p.Street,
            AddressNumber: p.Dependent ? (p.IsNewAddress ? p.AddressNumber : "") : p.AddressNumber,
            Complement: p.Dependent ? (p.IsNewAddress ? p.Complement : "") : p.Complement,
            District: p.Dependent ? (p.IsNewAddress ? p.District : "") : p.District,
            ZipCode: p.Dependent ? (p.IsNewAddress ? p.ZipCode : "") : p.ZipCode,
            City: p.Dependent ? (p.IsNewAddress ? p.City : "") : p.City,
            Region: p.Dependent ? (p.IsNewAddress ? p.Region : "") : p.Region,
            IsNewAddress: p.Dependent ? (p.IsNewAddress ? "Sim" : "Nao") : "",
            Email: p.Email,
            NeedValidateEmail: p.NeedValidateEmail ? "Sim" : "Nao",
            Telephone: p.Telephone,
            Mobile: p.Mobile,
            EnableDelivery: p.EnableDelivery ? "Sim" : "Nao",
            ActivationDate: this.datePipe.transform(p.ActivationDate, "dd/MM/yyyy"),
            Active: p.Active ? "Ativado" : "Desativado",
          });
        });
      }
    }

    if (rows.length > 0) {
      this.exportInternalService.exportTo(rows, columns, "Beneficiarios", this.getFilters().get("format").value);
      this.toast.showSuccessToast("Download do relatório de beneficiários realizado com sucesso!");
      this.exportService.setProcessStatus(0);
    } else this.toast.showWarningToast("Não há itens para download.");
  }

  getDescription(value: any, args: any): any {
    const indexOf = Object.keys(args).indexOf(value);
    return Object.values(args)[indexOf];
  }
}
